import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import type { TrialPlatform } from '~/features/trial/types/trial.types';

const TrialCreatePage = lazy(() => import('~/features/trial/pages/trial-create-page'));

export const Route = createFileRoute('/_authenticated/_tenant/trial/$platform/create')({
  component: RouteComponent,
});

function RouteComponent() {
  const { platform } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <TrialCreatePage platform={platform as TrialPlatform} />
    </Suspense>
  );
}
